import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Section } from '../components';
import { selectedVehicleSelector } from '../../../../selectors';
import { COLOR_SUCCESSFUL } from '../../../../constants';
import { FormattedAmount } from '../../../../components';

const StyledFormattedAmount = styled(FormattedAmount)`
  color: ${COLOR_SUCCESSFUL}
`;

const AdditionalFees = ({ vehicle }) => {
  const fees = (vehicle && vehicle.additional_fees) || [];
  if (!fees.length) return null;

  return fees.map(fee => (
    <Section key={fee.id} title={fee.fee_type} xs={6} md={3}>
      <StyledFormattedAmount amount={fee.fee_amount} />
    </Section>
  ));
};

const mapStateToProps = state => ({
  vehicle: selectedVehicleSelector(state),
});

export default connect(mapStateToProps)(AdditionalFees);
